<template>
  <footer v-if="!login">
    <div class="container">
      <div class="footer-content">
        <div class="footer-brand">
          <img :src="images.logo" />
          <p>
            Construimos hogares y entornos que mejoran la calidad de vida de las
            personas y aportan al desarrollo de la ciudad.
          </p>
        </div>
        <div class="footer-contact">
          <label>Contacto</label>
          <ul>
            <li><a href="tel:6003940000">6003940000</a></li>
            <li><a href="mailto:clientes@bricsa.cl">clientes@bricsa.cl</a></li>
          </ul>
          <ul>
            <li><router-link to="/bases-legales">Bases Legales</router-link></li>
          </ul>
        </div>
        <div class="footer-rrss">
          <label> Redes Sociales</label>
          <div class="footer-rrss_container">
            <a><img :src="images.facebook" /></a>
            <a> <img :src="images.instagram" /></a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data(){
    return {
      images: {
                facebook: process.env.BASE_URL +'./media/icons/facebook.png',
                instagram: process.env.BASE_URL + './media/icons/instagram.png',
                logo: process.env.BASE_URL + './media/logo-bricsa-blanco.png'
            }
    }
  },
  computed: {
    login: function () {
      return this.$route.path.indexOf("/login") === 0;
    },
  },
};
</script>

<style lang="scss" scoped>
footer {
  background-color: var(--bricsa-red);
  .footer-content {
    display: grid;
    grid-template-columns: repeat(3, 32%);
    justify-content: space-between;
    padding: 50px 20px;
    @media screen and(max-width:1025px) {
      grid-template-columns: repeat(2, 48%);
      row-gap: 20px;
    }
    .footer-brand {
      display: grid;
      justify-items: left;
      grid-template-rows: repeat(2, max-content);
      row-gap: 20px;
      @media screen and(max-width:1025px) {
        grid-row: 1/3;
      }
      p {
        color: #fff;
        text-align: left;
        width: 70%;
        @media screen and(max-width:1025px) {
          width: 100%;
        }
      }
    }
    .footer-contact {
      display: grid;
      row-gap: 10px;
      grid-template-rows: repeat(2, max-content);
      row-gap: 20px;
      label {
        color: #fff;
        display: block;
        width: 100%;
        text-align: left;
        font-size: 18px;
        font-weight: bold;
      }
      ul {
        li {
          text-align: left;
          a {
            color: #fff;
            transition: 400ms;
            &:hover {
              color: var(--bricsa-orange);
            }
          }
        }
      }
    }
    .footer-rrss {
      display: grid;
      row-gap: 10px;
      grid-template-rows: repeat(2, max-content);
      row-gap: 20px;
      label {
        color: #fff;
        display: block;
        width: 100%;
        text-align: left;
        font-size: 18px;
        font-weight: bold;
      }
      .footer-rrss_container {
        display: flex;
        a {
          margin-right: 10px;
          img {
            width: 20px;
          }
        }
      }
    }
    label {
      text-align: left;
    }
  }
  .footer-copyright {
    display: flex;
    justify-content: center;
    background-color: var(--bricsa-red-dark);
    padding: 10px 0;
    color: #fff;
    a {
      color: #fff;
      font-weight: bold;
      transition: 400ms;
      &:hover {
        color: var(--bricsa-orange);
      }
    }
  }
}
</style>
